import React from "react";
import BaseForm from "./../common/baseForm";
import BaseSelectInput from "./../common/baseSelectInput";
import UserRolesInput from "./userRolesInput";

import {
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Card,
  CardHeader,
  CardBody, Label,
} from "reactstrap";
import Joi from "joi-browser";
import http from "../../services/httpService";
import {toast} from "react-toastify";

class UserCustomerServiceForm extends BaseForm {

  state = {
    data: {},
    errors: {},
    isLoaded : false
  }
  
  schema = {
    accessFailedCount: Joi.number().required().label("accessFailedCount"),
    firstName: Joi.string().required().label("FirstName"),
    lastName: Joi.string().required().label("LastName"),
    createDate: Joi.string().required().label("Create date"),
    cultureName: Joi.string().required().label("Culture"),
    phoneNumber: Joi.string().required().label("Phone number"),
    description: Joi.string().allow("").allow(null).optional().label("Description"),
    email: Joi.string().email(),
    emailConfirmed: Joi.boolean(),
    searchProfile: Joi.optional(),
    userSearchProfileId: Joi.optional(),
    id: Joi.string(),
    isActive: Joi.boolean(),
    lockoutEnabled: Joi.boolean(),
    lockoutEnd: Joi.string().allow(null),
    modifiedDate: Joi.string().required(),
    onboardingState: Joi.optional(),
    idVerificationState: Joi.optional(),
    phoneNumberConfirmed: Joi.boolean(),
    roles: Joi.array(),
    twoFactorEnabled: Joi.boolean(),
    userRoleNames: Joi.array().min(1),
    unsubscribedDate: Joi.optional()
  };

  async componentDidMount() {
    const { data } = await http.get("users/edit/" + this.props.userId);
    this.setState({
      data,
      isLoaded: true
    });
  }

  doSubmit = async () => {
    try {
      const { data } = this.state;
      await http.post("users/customerserviceedit", data);
      toast.success("user details saved");
    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        const errors = { ...this.state.errors };
        errors.username = ex.response.data;
        this.setState({ errors });
      }
    }
  }

  handleRolesChange = ({ currentTarget: input }) => {
    const data = { ...this.state.data };
    if (input.checked) {
      data.userRoleNames.push(input.value);
    } else {
      data.userRoleNames = data.userRoleNames.filter(ur => ur !== input.value);
    }
    const errors = this.checkErrors({
      name: input.name,
      value: data.userRoleNames
    });
    this.setState({ data, errors });
  };
  render() {
    if (!this.state.isLoaded) return null;

    const {
      firstName,
      lastName,
        id,
      roles,
      userRoleNames,
      createDate,
        cultureName,
      modifiedDate,
      onboardingState,
      idVerificationState,
      unsubscribedDate
    } = this.state.data;

    const fullName = firstName + " " + lastName;
    return (
        <Form onSubmit={this.handleSubmit} className="mt-4">
          <Card>
            <Row>
              <Col>
                <CardHeader>
                  <strong>{fullName}</strong>
                </CardHeader>
              </Col>
            </Row>
            <CardBody>
              <Row>
                <Col sm="10">
                  <Input hidden value={id} readOnly />
                  <Row>
                    <Col>
                      <FormGroup check className="mb-3">
                        {this.renderCheckbox( "isActive", "Active", true )}
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col>{this.renderInput("firstName", "First name", "text", true)}</Col>
                    <Col>{this.renderInput("lastName", "Last name", "text", true)}</Col>
                    <Col>
                      <BaseSelectInput
                        name="cultureName"
                        label="Culture"
                        options={[
                          { name: "en", value: "en" },
                          { name: "nl", value: "nl" }
                        ]}
                        value={cultureName}
                        disabled ={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col>{this.renderInput("email", "Email")}</Col>
                    <Col>
                      <FormGroup check>
                        {this.renderCheckbox( "emailConfirmed", "Email confirmed", true )}
                      </FormGroup>
                    </Col>
                    <Col>{this.renderInput("phoneNumber", "Phone number", "text", true)}</Col>
                  </Row>
                  <Row>
                    <Col>{this.renderInput("description", "Description")}</Col>
                  </Row>
                  <Row>
                    <Col>
                      <span className="text-muted">
                        created: {createDate} | modified: {modifiedDate} 
                      </span>
                      {unsubscribedDate &&
                        <div className="text-muted">
                        unsubscribed: {unsubscribedDate}
                      </div>
                      }
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Row><Col>
                  <div>
                    <UserRolesInput
                      roles={roles}
                      userRoleNames={userRoleNames}
                      errors={this.state.errors}
                      onRolesChange={this.handleRolesChange}
                      disabled={true}
                    />
                  </div>
                  </Col>
                  </Row>
                  {onboardingState &&
                  <Row><Col className="mt-4">Onboarding state: {onboardingState}</Col></Row>
                  }
                  {idVerificationState && 
                  <Row><Col className="mt-4">Id verification state: {idVerificationState}</Col></Row>
                  }
                </Col>
              </Row>
            </CardBody>
          </Card>
          <Row>
            <Col className="my-3">{this.renderButton("Save user details")}</Col>
          </Row>
        </Form>
    );
  }
}

export default UserCustomerServiceForm;
